import React from "react";
import { Box, Typography } from "@mui/material";

const PreviewBox = ({ imageUrl, primaryColor, fontColor, fontStyle }) => {
  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px",
        textAlign: "center",

        width: "25vw",
        height: "40vh",
      }}
    >
      <Typography>Chosen Customisation: </Typography>

      {imageUrl && (
        <Box
          component="img"
          src={imageUrl}
          alt="Preview"
          sx={{
            width: "100%",
            height: "80%",
            objectFit: "contain",
            borderRadius: "8px",
            marginBottom: "16px",
          }}
        />
      )}
    </Box>
  );
};

export default PreviewBox;
